<script setup lang="ts">
import { DateTime } from "luxon";
import PostApi from "../api/post";
import Post from "../models/post";
import PostProperties from "../models/postProperties";
import { onMounted, ref } from "vue";
import VButton from "../components/VButton.vue";
import VTextArea from "../components/VTextArea.vue";
import VTextField from "../components/VTextField.vue";
import {
  utcToLocalDatetimeString,
  localToUtcIsoString,
} from "../util/datetime";

const props = defineProps<{
  post: Post;
}>();

const emit = defineEmits<(e: "update", properties: PostProperties) => void>();

const text = ref("");
const timestamp = ref("");

async function onUpdate() {
  if (props.post.routineId === undefined) {
    console.error("Missing routineId");
    return;
  }

  // Convert the local timestamp back to UTC before saving
  const utcTimestamp = localToUtcIsoString(timestamp.value);

  const properties = new PostProperties(
    props.post.routineId,
    text.value,
    utcTimestamp,
  );

  if (props.post.id === undefined) {
    console.error("Missing post ID");
    return;
  }

  await PostApi.update(props.post.id, properties);
  emit("update", properties);
}

onMounted(() => {
  text.value = props.post.text || "";
  timestamp.value = utcToLocalDatetimeString(props.post.timestamp);
});
</script>

<template>
  <div class="card new-post">
    <h3 class="inline">Edit entry</h3>
    <VTextArea
      v-model="text"
      :rows="5"
      placeholder="Write something..."
      class="mb-3"
    />
    <VTextField v-model="timestamp" type="datetime-local" class="mb-3" />
    <VButton class="purple white--text" @click="onUpdate()">
      <span>Save</span>
    </VButton>
  </div>
</template>

<style lang="scss" scoped>
.inline {
  display: inline-block;
}

.heading {
  align-items: baseline;
  display: flex;
  flex-direction: row;
  gap: 1em;
}

.post {
  white-space: pre-line;
}

.post-card {
  padding: 16px 0;
}

.post-card:not(:last-child) {
  border-bottom: 1px solid #ccc;
}

.avatar {
  border-radius: 4px;
  padding: 8px;
}

.link {
  display: inline-flex;
}

.new-post {
  min-width: 600px;
}
</style>
